export default "__VITE_ASSET__BJxi2Pp6__"